"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllTimeFilterItem = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ListItem_1 = require("../ListItem/ListItem");
exports.AllTimeFilterItem = function (_a) {
    var className = _a.className, filterOption = _a.filterOption, selectedFilterOption = _a.selectedFilterOption, onSelectedFilterOptionChange = _a.onSelectedFilterOptionChange;
    return (react_1.default.createElement(ListItem_1.ListItem, { isSelected: filterOption.localIdentifier === selectedFilterOption.localIdentifier, onClick: function () { return onSelectedFilterOptionChange(filterOption); }, className: classnames_1.default("s-all-time", className) }, filterOption.name ? filterOption.name : react_1.default.createElement(react_intl_1.FormattedMessage, { id: "filters.allTime.title" })));
};
//# sourceMappingURL=AllTimeFilterItem.js.map